import { FaultCategory } from "../../../../../graphql";
export var useFaultCategories = function (environment) {
    var faultCategoriesToShow = [
        FaultCategory.aws,
        FaultCategory.az_failover,
        FaultCategory.blackhole,
        FaultCategory.network,
        FaultCategory.stress,
        FaultCategory.application_layer
    ];
    var prodFaultCategoriesToShow = [FaultCategory.aws];
    return environment.includes("prod")
        ? prodFaultCategoriesToShow
        : faultCategoriesToShow;
};
